import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, provide } from 'vue';

import { FadeTransition } from '@/modules/common/components/FadeTransition';

import {
  CreateSuggestedPortfolioComponents,
  ESuggestedPortfolioBuilderSteps
} from './helpers';

import {
  getSuggestedPortfolios,
  getSuggestedPortfolioDetails,
  createSuggestedPortfolio,
  IWallet,
  IGetSuggestedPortfolioDetailsResponse
} from '@/modules/wealth/services/suggested-portfolio-builder';


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestedPortfolioBuilder',
  setup(__props) {

const currentStep = ref(ESuggestedPortfolioBuilderSteps.INITIAL_INVESTMENT);
const goalDate = ref('');
const initialInvestmentFormatted = ref('0,00');
const initialInvestment = ref(0);
const isLoading = ref(false);
const isDetailsLoading = ref(false);
const suggestedPortfolios = ref([] as IWallet[]);
const managedPortfolioId = ref('');
const portfolioId = ref('');
const portfolioName = ref('');
const suggestedPortfolioDetails =
  ref<IGetSuggestedPortfolioDetailsResponse | null>(null);

const step = computed(() => {
  return {
    component: CreateSuggestedPortfolioComponents[currentStep.value]
  };
});

async function fetchGetSuggestedPortfolios() {
  try {
    isLoading.value = true;

    const data = await getSuggestedPortfolios(
      initialInvestment.value,
      goalDate.value
    );

    suggestedPortfolios.value = data.wallets;

    changeStep(ESuggestedPortfolioBuilderSteps.PORTFOLIO_SELECT);
  } catch (error) {
    console.error(error);
    changeStep(ESuggestedPortfolioBuilderSteps.ERROR);
  } finally {
    isLoading.value = false;
  }
}

async function fetchGetSuggestedPortfolioDetails() {
  try {
    isDetailsLoading.value = true;

    const data = await getSuggestedPortfolioDetails(
      managedPortfolioId.value,
      goalDate.value,
      initialInvestment.value
    );

    suggestedPortfolioDetails.value = data;
  } catch (error) {
    console.error(error);
    changeStep(ESuggestedPortfolioBuilderSteps.ERROR);
  } finally {
    isDetailsLoading.value = false;
  }
}

async function fetchCreateSuggestedPortfolio() {
  try {
    isLoading.value = true;

    const data = await createSuggestedPortfolio(
      portfolioName.value,
      goalDate.value,
      initialInvestment.value,
      managedPortfolioId.value
    );

    portfolioId.value = data.id;
    portfolioName.value = data.name;

    changeStep(ESuggestedPortfolioBuilderSteps.CONCLUSION);
  } catch (error) {
    console.error(error);
    changeStep(ESuggestedPortfolioBuilderSteps.ERROR);
  } finally {
    isLoading.value = false;
  }
}

function changeStep(step: ESuggestedPortfolioBuilderSteps) {
  currentStep.value = step;
}

function saveGoalDate(value: string) {
  goalDate.value = value;
}

function saveInitialInvestment(formatted: string, value: number) {
  initialInvestment.value = value;
  initialInvestmentFormatted.value = formatted;
}

function saveManagedPortfolioId(id: string) {
  managedPortfolioId.value = id;
  changeStep(ESuggestedPortfolioBuilderSteps.DETAILS);
  fetchGetSuggestedPortfolioDetails();
}

function confirmDetails(name: string) {
  portfolioName.value = name;
  fetchCreateSuggestedPortfolio();
}

provide('goalDate', goalDate);
provide('initialInvestmentFormatted', initialInvestmentFormatted);
provide('isLoading', isLoading);
provide('suggestedPortfolios', suggestedPortfolios);
provide('suggestedPortfolioDetails', suggestedPortfolioDetails);
provide('portfolioName', portfolioName);
provide('portfolioId', portfolioId);
provide('isDetailsLoading', isDetailsLoading);

provide('changeStep', changeStep);
provide('saveGoalDate', saveGoalDate);
provide('saveInitialInvestment', saveInitialInvestment);
provide('getPortfolios', fetchGetSuggestedPortfolios);
provide('savePortfolio', saveManagedPortfolioId);
provide('confirmDetails', confirmDetails);

return { __sfc: true,currentStep, goalDate, initialInvestmentFormatted, initialInvestment, isLoading, isDetailsLoading, suggestedPortfolios, managedPortfolioId, portfolioId, portfolioName, suggestedPortfolioDetails, step, fetchGetSuggestedPortfolios, fetchGetSuggestedPortfolioDetails, fetchCreateSuggestedPortfolio, changeStep, saveGoalDate, saveInitialInvestment, saveManagedPortfolioId, confirmDetails, FadeTransition }
}

})